/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetWorklists200Response } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { MultipleWorklistPatch } from '../models';
// @ts-ignore
import type { PostWorklistResponse } from '../models';
// @ts-ignore
import type { SearchWorklist } from '../models';
// @ts-ignore
import type { WorklistEntityType } from '../models';
// @ts-ignore
import type { WorklistPatch } from '../models';
// @ts-ignore
import type { WorklistPost } from '../models';
// @ts-ignore
import type { WorklistResponse } from '../models';
/**
 * WorklistApi - axios parameter creator
 * @export
 */
export const WorklistApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new worklist
         * @summary Create a new worklist
         * @param {WorklistEntityType} entityType 
         * @param {WorklistPost} worklistPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorklist: async (entityType: WorklistEntityType, worklistPost: WorklistPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('createWorklist', 'entityType', entityType)
            // verify required parameter 'worklistPost' is not null or undefined
            assertParamExists('createWorklist', 'worklistPost', worklistPost)
            const localVarPath = `/api/v1/worklist/{entityType}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(worklistPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a worklist
         * @summary Delete a worklist
         * @param {WorklistEntityType} entityType 
         * @param {string} worklistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorklist: async (entityType: WorklistEntityType, worklistId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('deleteWorklist', 'entityType', entityType)
            // verify required parameter 'worklistId' is not null or undefined
            assertParamExists('deleteWorklist', 'worklistId', worklistId)
            const localVarPath = `/api/v1/worklist/{entityType}/{worklistId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"worklistId"}}`, encodeURIComponent(String(worklistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a worklist by id
         * @summary Get a worklist by id
         * @param {WorklistEntityType} entityType 
         * @param {string} worklistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorklistById: async (entityType: WorklistEntityType, worklistId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getWorklistById', 'entityType', entityType)
            // verify required parameter 'worklistId' is not null or undefined
            assertParamExists('getWorklistById', 'worklistId', worklistId)
            const localVarPath = `/api/v1/worklist/{entityType}/{worklistId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"worklistId"}}`, encodeURIComponent(String(worklistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all worklists
         * @summary Get all worklists
         * @param {WorklistEntityType} entityType 
         * @param {boolean} userWorklists 
         * @param {boolean} getAllWorklists 
         * @param {SearchWorklist} searchWorklist 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorklists: async (entityType: WorklistEntityType, userWorklists: boolean, getAllWorklists: boolean, searchWorklist: SearchWorklist, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getWorklists', 'entityType', entityType)
            // verify required parameter 'userWorklists' is not null or undefined
            assertParamExists('getWorklists', 'userWorklists', userWorklists)
            // verify required parameter 'getAllWorklists' is not null or undefined
            assertParamExists('getWorklists', 'getAllWorklists', getAllWorklists)
            // verify required parameter 'searchWorklist' is not null or undefined
            assertParamExists('getWorklists', 'searchWorklist', searchWorklist)
            const localVarPath = `/api/v1/worklist/{entityType}/search`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (userWorklists !== undefined) {
                localVarQueryParameter['userWorklists'] = userWorklists;
            }

            if (getAllWorklists !== undefined) {
                localVarQueryParameter['getAllWorklists'] = getAllWorklists;
            }

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchWorklist, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refresh a worklist\'s metadata and entities
         * @summary Refresh a worklist\'s metadata and entities
         * @param {WorklistEntityType} entityType 
         * @param {string} worklistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshWorklist: async (entityType: WorklistEntityType, worklistId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('refreshWorklist', 'entityType', entityType)
            // verify required parameter 'worklistId' is not null or undefined
            assertParamExists('refreshWorklist', 'worklistId', worklistId)
            const localVarPath = `/api/v1/worklist/{entityType}/{entityType}/{worklistId}/refresh`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"worklistId"}}`, encodeURIComponent(String(worklistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update manual worklists entities
         * @summary Update manual worklists entities
         * @param {WorklistEntityType} entityType 
         * @param {MultipleWorklistPatch} multipleWorklistPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManualWorklistEntities: async (entityType: WorklistEntityType, multipleWorklistPatch: MultipleWorklistPatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('updateManualWorklistEntities', 'entityType', entityType)
            // verify required parameter 'multipleWorklistPatch' is not null or undefined
            assertParamExists('updateManualWorklistEntities', 'multipleWorklistPatch', multipleWorklistPatch)
            const localVarPath = `/api/v1/worklist/{entityType}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multipleWorklistPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a worklist
         * @summary Update a worklist
         * @param {WorklistEntityType} entityType 
         * @param {string} worklistId 
         * @param {WorklistPatch} worklistPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorklist: async (entityType: WorklistEntityType, worklistId: string, worklistPatch: WorklistPatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('updateWorklist', 'entityType', entityType)
            // verify required parameter 'worklistId' is not null or undefined
            assertParamExists('updateWorklist', 'worklistId', worklistId)
            // verify required parameter 'worklistPatch' is not null or undefined
            assertParamExists('updateWorklist', 'worklistPatch', worklistPatch)
            const localVarPath = `/api/v1/worklist/{entityType}/{worklistId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"worklistId"}}`, encodeURIComponent(String(worklistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(worklistPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorklistApi - functional programming interface
 * @export
 */
export const WorklistApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorklistApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new worklist
         * @summary Create a new worklist
         * @param {WorklistEntityType} entityType 
         * @param {WorklistPost} worklistPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorklist(entityType: WorklistEntityType, worklistPost: WorklistPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostWorklistResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorklist(entityType, worklistPost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorklistApi.createWorklist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a worklist
         * @summary Delete a worklist
         * @param {WorklistEntityType} entityType 
         * @param {string} worklistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorklist(entityType: WorklistEntityType, worklistId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorklist(entityType, worklistId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorklistApi.deleteWorklist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a worklist by id
         * @summary Get a worklist by id
         * @param {WorklistEntityType} entityType 
         * @param {string} worklistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorklistById(entityType: WorklistEntityType, worklistId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorklistResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorklistById(entityType, worklistId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorklistApi.getWorklistById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all worklists
         * @summary Get all worklists
         * @param {WorklistEntityType} entityType 
         * @param {boolean} userWorklists 
         * @param {boolean} getAllWorklists 
         * @param {SearchWorklist} searchWorklist 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorklists(entityType: WorklistEntityType, userWorklists: boolean, getAllWorklists: boolean, searchWorklist: SearchWorklist, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWorklists200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorklists(entityType, userWorklists, getAllWorklists, searchWorklist, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorklistApi.getWorklists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Refresh a worklist\'s metadata and entities
         * @summary Refresh a worklist\'s metadata and entities
         * @param {WorklistEntityType} entityType 
         * @param {string} worklistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshWorklist(entityType: WorklistEntityType, worklistId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshWorklist(entityType, worklistId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorklistApi.refreshWorklist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update manual worklists entities
         * @summary Update manual worklists entities
         * @param {WorklistEntityType} entityType 
         * @param {MultipleWorklistPatch} multipleWorklistPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateManualWorklistEntities(entityType: WorklistEntityType, multipleWorklistPatch: MultipleWorklistPatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateManualWorklistEntities(entityType, multipleWorklistPatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorklistApi.updateManualWorklistEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a worklist
         * @summary Update a worklist
         * @param {WorklistEntityType} entityType 
         * @param {string} worklistId 
         * @param {WorklistPatch} worklistPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorklist(entityType: WorklistEntityType, worklistId: string, worklistPatch: WorklistPatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorklist(entityType, worklistId, worklistPatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorklistApi.updateWorklist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorklistApi - factory interface
 * @export
 */
export const WorklistApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorklistApiFp(configuration)
    return {
        /**
         * Create a new worklist
         * @summary Create a new worklist
         * @param {WorklistApiCreateWorklistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorklist(requestParameters: WorklistApiCreateWorklistRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostWorklistResponse> {
            return localVarFp.createWorklist(requestParameters.entityType, requestParameters.worklistPost, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a worklist
         * @summary Delete a worklist
         * @param {WorklistApiDeleteWorklistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorklist(requestParameters: WorklistApiDeleteWorklistRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteWorklist(requestParameters.entityType, requestParameters.worklistId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a worklist by id
         * @summary Get a worklist by id
         * @param {WorklistApiGetWorklistByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorklistById(requestParameters: WorklistApiGetWorklistByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorklistResponse> {
            return localVarFp.getWorklistById(requestParameters.entityType, requestParameters.worklistId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all worklists
         * @summary Get all worklists
         * @param {WorklistApiGetWorklistsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorklists(requestParameters: WorklistApiGetWorklistsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetWorklists200Response> {
            return localVarFp.getWorklists(requestParameters.entityType, requestParameters.userWorklists, requestParameters.getAllWorklists, requestParameters.searchWorklist, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Refresh a worklist\'s metadata and entities
         * @summary Refresh a worklist\'s metadata and entities
         * @param {WorklistApiRefreshWorklistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshWorklist(requestParameters: WorklistApiRefreshWorklistRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.refreshWorklist(requestParameters.entityType, requestParameters.worklistId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update manual worklists entities
         * @summary Update manual worklists entities
         * @param {WorklistApiUpdateManualWorklistEntitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManualWorklistEntities(requestParameters: WorklistApiUpdateManualWorklistEntitiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateManualWorklistEntities(requestParameters.entityType, requestParameters.multipleWorklistPatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a worklist
         * @summary Update a worklist
         * @param {WorklistApiUpdateWorklistRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorklist(requestParameters: WorklistApiUpdateWorklistRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateWorklist(requestParameters.entityType, requestParameters.worklistId, requestParameters.worklistPatch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorklistApi - interface
 * @export
 * @interface WorklistApi
 */
export interface WorklistApiInterface {
    /**
     * Create a new worklist
     * @summary Create a new worklist
     * @param {WorklistApiCreateWorklistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistApiInterface
     */
    createWorklist(requestParameters: WorklistApiCreateWorklistRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostWorklistResponse>;

    /**
     * Delete a worklist
     * @summary Delete a worklist
     * @param {WorklistApiDeleteWorklistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistApiInterface
     */
    deleteWorklist(requestParameters: WorklistApiDeleteWorklistRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get a worklist by id
     * @summary Get a worklist by id
     * @param {WorklistApiGetWorklistByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistApiInterface
     */
    getWorklistById(requestParameters: WorklistApiGetWorklistByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorklistResponse>;

    /**
     * Get all worklists
     * @summary Get all worklists
     * @param {WorklistApiGetWorklistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistApiInterface
     */
    getWorklists(requestParameters: WorklistApiGetWorklistsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetWorklists200Response>;

    /**
     * Refresh a worklist\'s metadata and entities
     * @summary Refresh a worklist\'s metadata and entities
     * @param {WorklistApiRefreshWorklistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistApiInterface
     */
    refreshWorklist(requestParameters: WorklistApiRefreshWorklistRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update manual worklists entities
     * @summary Update manual worklists entities
     * @param {WorklistApiUpdateManualWorklistEntitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistApiInterface
     */
    updateManualWorklistEntities(requestParameters: WorklistApiUpdateManualWorklistEntitiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Update a worklist
     * @summary Update a worklist
     * @param {WorklistApiUpdateWorklistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistApiInterface
     */
    updateWorklist(requestParameters: WorklistApiUpdateWorklistRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for createWorklist operation in WorklistApi.
 * @export
 * @interface WorklistApiCreateWorklistRequest
 */
export interface WorklistApiCreateWorklistRequest {
    /**
     * 
     * @type {WorklistEntityType}
     * @memberof WorklistApiCreateWorklist
     */
    readonly entityType: WorklistEntityType

    /**
     * 
     * @type {WorklistPost}
     * @memberof WorklistApiCreateWorklist
     */
    readonly worklistPost: WorklistPost
}

/**
 * Request parameters for deleteWorklist operation in WorklistApi.
 * @export
 * @interface WorklistApiDeleteWorklistRequest
 */
export interface WorklistApiDeleteWorklistRequest {
    /**
     * 
     * @type {WorklistEntityType}
     * @memberof WorklistApiDeleteWorklist
     */
    readonly entityType: WorklistEntityType

    /**
     * 
     * @type {string}
     * @memberof WorklistApiDeleteWorklist
     */
    readonly worklistId: string
}

/**
 * Request parameters for getWorklistById operation in WorklistApi.
 * @export
 * @interface WorklistApiGetWorklistByIdRequest
 */
export interface WorklistApiGetWorklistByIdRequest {
    /**
     * 
     * @type {WorklistEntityType}
     * @memberof WorklistApiGetWorklistById
     */
    readonly entityType: WorklistEntityType

    /**
     * 
     * @type {string}
     * @memberof WorklistApiGetWorklistById
     */
    readonly worklistId: string
}

/**
 * Request parameters for getWorklists operation in WorklistApi.
 * @export
 * @interface WorklistApiGetWorklistsRequest
 */
export interface WorklistApiGetWorklistsRequest {
    /**
     * 
     * @type {WorklistEntityType}
     * @memberof WorklistApiGetWorklists
     */
    readonly entityType: WorklistEntityType

    /**
     * 
     * @type {boolean}
     * @memberof WorklistApiGetWorklists
     */
    readonly userWorklists: boolean

    /**
     * 
     * @type {boolean}
     * @memberof WorklistApiGetWorklists
     */
    readonly getAllWorklists: boolean

    /**
     * 
     * @type {SearchWorklist}
     * @memberof WorklistApiGetWorklists
     */
    readonly searchWorklist: SearchWorklist

    /**
     * 
     * @type {number}
     * @memberof WorklistApiGetWorklists
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof WorklistApiGetWorklists
     */
    readonly pgSize?: number
}

/**
 * Request parameters for refreshWorklist operation in WorklistApi.
 * @export
 * @interface WorklistApiRefreshWorklistRequest
 */
export interface WorklistApiRefreshWorklistRequest {
    /**
     * 
     * @type {WorklistEntityType}
     * @memberof WorklistApiRefreshWorklist
     */
    readonly entityType: WorklistEntityType

    /**
     * 
     * @type {string}
     * @memberof WorklistApiRefreshWorklist
     */
    readonly worklistId: string
}

/**
 * Request parameters for updateManualWorklistEntities operation in WorklistApi.
 * @export
 * @interface WorklistApiUpdateManualWorklistEntitiesRequest
 */
export interface WorklistApiUpdateManualWorklistEntitiesRequest {
    /**
     * 
     * @type {WorklistEntityType}
     * @memberof WorklistApiUpdateManualWorklistEntities
     */
    readonly entityType: WorklistEntityType

    /**
     * 
     * @type {MultipleWorklistPatch}
     * @memberof WorklistApiUpdateManualWorklistEntities
     */
    readonly multipleWorklistPatch: MultipleWorklistPatch
}

/**
 * Request parameters for updateWorklist operation in WorklistApi.
 * @export
 * @interface WorklistApiUpdateWorklistRequest
 */
export interface WorklistApiUpdateWorklistRequest {
    /**
     * 
     * @type {WorklistEntityType}
     * @memberof WorklistApiUpdateWorklist
     */
    readonly entityType: WorklistEntityType

    /**
     * 
     * @type {string}
     * @memberof WorklistApiUpdateWorklist
     */
    readonly worklistId: string

    /**
     * 
     * @type {WorklistPatch}
     * @memberof WorklistApiUpdateWorklist
     */
    readonly worklistPatch: WorklistPatch
}

/**
 * WorklistApi - object-oriented interface
 * @export
 * @class WorklistApi
 * @extends {BaseAPI}
 */
export class WorklistApi extends BaseAPI implements WorklistApiInterface {
    /**
     * Create a new worklist
     * @summary Create a new worklist
     * @param {WorklistApiCreateWorklistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistApi
     */
    public createWorklist(requestParameters: WorklistApiCreateWorklistRequest, options?: RawAxiosRequestConfig) {
        return WorklistApiFp(this.configuration).createWorklist(requestParameters.entityType, requestParameters.worklistPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a worklist
     * @summary Delete a worklist
     * @param {WorklistApiDeleteWorklistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistApi
     */
    public deleteWorklist(requestParameters: WorklistApiDeleteWorklistRequest, options?: RawAxiosRequestConfig) {
        return WorklistApiFp(this.configuration).deleteWorklist(requestParameters.entityType, requestParameters.worklistId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a worklist by id
     * @summary Get a worklist by id
     * @param {WorklistApiGetWorklistByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistApi
     */
    public getWorklistById(requestParameters: WorklistApiGetWorklistByIdRequest, options?: RawAxiosRequestConfig) {
        return WorklistApiFp(this.configuration).getWorklistById(requestParameters.entityType, requestParameters.worklistId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all worklists
     * @summary Get all worklists
     * @param {WorklistApiGetWorklistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistApi
     */
    public getWorklists(requestParameters: WorklistApiGetWorklistsRequest, options?: RawAxiosRequestConfig) {
        return WorklistApiFp(this.configuration).getWorklists(requestParameters.entityType, requestParameters.userWorklists, requestParameters.getAllWorklists, requestParameters.searchWorklist, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refresh a worklist\'s metadata and entities
     * @summary Refresh a worklist\'s metadata and entities
     * @param {WorklistApiRefreshWorklistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistApi
     */
    public refreshWorklist(requestParameters: WorklistApiRefreshWorklistRequest, options?: RawAxiosRequestConfig) {
        return WorklistApiFp(this.configuration).refreshWorklist(requestParameters.entityType, requestParameters.worklistId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update manual worklists entities
     * @summary Update manual worklists entities
     * @param {WorklistApiUpdateManualWorklistEntitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistApi
     */
    public updateManualWorklistEntities(requestParameters: WorklistApiUpdateManualWorklistEntitiesRequest, options?: RawAxiosRequestConfig) {
        return WorklistApiFp(this.configuration).updateManualWorklistEntities(requestParameters.entityType, requestParameters.multipleWorklistPatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a worklist
     * @summary Update a worklist
     * @param {WorklistApiUpdateWorklistRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorklistApi
     */
    public updateWorklist(requestParameters: WorklistApiUpdateWorklistRequest, options?: RawAxiosRequestConfig) {
        return WorklistApiFp(this.configuration).updateWorklist(requestParameters.entityType, requestParameters.worklistId, requestParameters.worklistPatch, options).then((request) => request(this.axios, this.basePath));
    }
}

